import { render, staticRenderFns } from "./NewProject.vue?vue&type=template&id=0dd43c55&scoped=true"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"
import style0 from "./NewProject.vue?vue&type=style&index=0&id=0dd43c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd43c55",
  null
  
)

export default component.exports